
import api from '../../api/vo2api'
import moment from 'moment'

import BaseEntity from './BaseEntity';

let baseEntity = new BaseEntity({

    getEntityType() {
        return 'athlete';
    },

    getEmptyName() {
        return '(empty name)';
    },

    getById(orgId, id) {
        return api.getAthlete(orgId, id)
    },

    deleteById(orgId, entity) {
        return api.deleteAthlete(orgId, entity)
    },

    getItems(orgId) {
        return api.getAthleteList(orgId)
    },

    insertOrUpdate(orgId, entity) {
        if(entity) {

            if(entity.birthDateObject) {
                entity.birthDate = moment(entity.birthDateObject).utc().format()
            }

        }
        return api.insertOrUpdateAthlete(orgId, entity);
    },

    getEntityId(entity) {
        if(entity) {
            return entity.athleteId;
        }
        return null
    },
    augmentEntity( base, entity ) {
        if(entity) {
            entity.birthDateObject = (entity.birthDate && entity.birthDate != '') ? moment(entity.birthDate).toDate() : null
            entity.sanitizedName = base.normalizeEntityName(entity.athleteId, entity, this.getEmptyName())

            entity.weight = (entity.weight ? Math.max(entity.weight, 0) : 0)
            entity.height = (entity.height ? Math.max(entity.height, 0) : 0)

            let summary = ''
            if(entity.birthDateObject) {
                summary += moment().diff(moment(entity.birthDateObject),'years') + 'yrs, '
            }
            summary += entity.weight + ( entity.weightUnit == 'kilogram' ? 'kg, ' : 'lb, ');
            summary += entity.height + ( entity.heightUnit == 'centimeter' ? 'cm, ' : 'inches, ');
            summary += entity.sex;

            entity.summary = summary
        }
        return entity
    }
});

const state = {
    ...baseEntity.state,
};
const getters = {
    ...baseEntity.getters,
};
const actions = {
    ...baseEntity.actions,
};
const mutations = {
    ...baseEntity.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};